import { ar } from "./ar";
import { en } from "./en";
import type { Locale } from "./paths";
import type { Dictionary } from "./types";

export const dictionaries: Record<Locale, Dictionary> = { ar, en };
